export const notificationsTypes = {
  NotifierService: Symbol.for("NotifierService"),
}
